import { createSlice } from "@reduxjs/toolkit";

const extractedDataSlice = createSlice({
    name: "extractedData",
    initialState: {
        extractedData: null,
        extractedDataError: null,
        extractedDataLoading: false,
    },
    reducers: {
        setExtractedData: (state, { payload }) => {
            state.extractedData = payload;
        },
        setExtractedDataError: (state, { payload }) => {
            state.extractedDataError = payload;
        },
        setExtractedDataLoading: (state, { payload }) => {
            state.extractedDataLoading = payload;
        },
    }
});

export const { setExtractedData, setExtractedDataError, setExtractedDataLoading } = extractedDataSlice.actions;

export default extractedDataSlice.reducer;